const InfoPage = () => {
  return (
    <div className="py-10">
      {window?.__version && (
        <p className="text-body">Version: {window.__version}</p>
      )}
    </div>
  );
};

export default InfoPage;
